import React from "react";
import { openWhatsApp } from "../lib/whatsapp";

/**
 * Root-level error boundary. Prevents any uncaught React rendering error
 * from producing a blank white screen for the visitor.
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error("[ErrorBoundary]", error, info?.componentStack);
    }

    reset = () => this.setState({ hasError: false, error: null });

    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div
                data-testid="error-boundary"
                className="min-h-screen bg-brand-navy text-white flex items-center justify-center px-6"
            >
                <div className="max-w-lg rounded-2xl border border-white/10 bg-white/5 p-8 text-center">
                    <div className="font-display text-2xl font-extrabold text-brand-gold">
                        Something went wrong
                    </div>
                    <p className="mt-3 text-sm text-white/70">
                        We hit a temporary issue rendering this page. Please try again — or contact
                        us on WhatsApp for a booking.
                    </p>
                    <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
                        <button
                            onClick={() => {
                                this.reset();
                                if (typeof window !== "undefined") window.location.reload();
                            }}
                            className="rounded-lg bg-brand-gold px-4 py-2 text-sm font-bold text-brand-navy hover:bg-brand-goldDark"
                        >
                            Reload page
                        </button>
                        <button
                            type="button"
                            onClick={() =>
                                openWhatsApp(
                                    "919425712055",
                                    "Hi VVPSS, I ran into an issue on your website but would still like to book. Please help.",
                                    "error-boundary",
                                )
                            }
                            className="rounded-lg border border-white/20 px-4 py-2 text-sm font-bold text-white hover:bg-white/10"
                        >
                            WhatsApp Booking
                        </button>
                    </div>
                    {process.env.NODE_ENV !== "production" && this.state.error && (
                        <pre className="mt-4 max-h-40 overflow-auto text-left text-[10px] text-white/50">
                            {String(this.state.error?.message || this.state.error)}
                        </pre>
                    )}
                </div>
            </div>
        );
    }
}
